import styled from "styled-components";

export const Container = styled.div`
  position: sticky;
  top: 0;
  padding: 0 1rem;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${({ theme }) => theme.border};
  cursor: pointer;
  background-color: ${({ theme }) => theme.box};
  .tickets-number {
    position: absolute;
    background-color: #ffbf00;
    padding: 0px 8px;
    height: fit-content;
    border-radius: 100%;
    font-size: 12px;
    margin-right: -9px;
    margin-top: -7px;
    color: #000;
  }
`;

export const Icon = styled.div`
  margin: 0 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  svg {
    cursor: pointer;
    &:hover {
      color: red;
      transition: 0.4s all ease-in-out;
    }
  }
`;
